import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';
import { trigger, transition, animate, style } from '@angular/animations';
import { TCCPCommonService } from '../../services/tccp-common.service';
import { Content, Resources, Videos } from '../../../shared/models/content';
import { TCCPLocalStorageService } from '../../../shared/services/tccp-local-storage.service'
import { VideoPlayerDialogComponent } from '../video-player-dialog/video-player-dialog.component';

@Component({
  selector: 'app-resources-container',
  templateUrl: './resources-container.component.html',
  styleUrls: ['./resources-container.component.scss'],
  animations: [
    trigger('slideInOut', [
      transition(':enter', [
        style({ transform: 'translateY(-100%)' }),
        animate('200ms ease-in', style({ transform: 'translateY(0%)' }))
      ]),
      transition(':leave', [
        animate('200ms ease-in', style({ transform: 'translateY(-100%)' }))
      ])
    ])
  ]
})
export class ResourcesContainerComponent implements OnInit {

  @Input() isOpened = false ;
  @Input() type: string = null;
  @Input() data: any = {};
  @Output() showResourceCount = new EventEmitter();
  public appName;
  public content: Content[];
  public videos: Videos[];
  public resources: Resources[];
  public Group: string[];
  public featureType: string;
  public resourceDetails = [];

  constructor(
    private commonService: TCCPCommonService, private localstorageService: TCCPLocalStorageService, public dialog: MatDialog) {
  }

  openDialog(url: string) {
    const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
    const match = url.match(regExp);
    const videoId = (match && match[7].length === 11) ? match[7] : false ;
    const name: Content = this.content.find(x => x['videoUrl'] === url);
    const videoName = name['videoName'];
    this.dialog.open(VideoPlayerDialogComponent, { data: { videoUrl: videoId, name: videoName }, panelClass: 'icon-outside' });
  }

  valueChanged() {
    this.showResourceCount.emit(this.resourceDetails);
  }

  ngOnInit() {
    if (this.localstorageService.getFeatureType() === 'internal') {
      this.featureType = 'internal';
    } else {
      this.featureType = 'external';
    }
    this.appName = environment.applicationName;
    if (this.type === 'videos') {
      this.getAllVideos();
    } else if (this.type === 'resources') {
      this.getAllResources();
    }
  }

  openFileInNewTab(e, url) {
    if (e) {
      e.preventDefault();
    }
    e.stopPropagation();
    if (url) {
      window.open(url, '_blank');
    }
  }

  getAllVideos() {
    this.commonService.getAllVideos(this.featureType).subscribe(data => {
      if (data) {
        this.Group = data.map(x => x.videos.videoGroup);
        this.Group = this.Group.filter((n, i) => this.Group.indexOf(n) === i).sort((a, b) => a > b ? 1 : -1);
        this.content = data.map(x => x.videos).sort((a, b) => a.videoName > b.videoName ? 1 : -1);
        this.resourceDetails.push({ type: 'videos', count: this.content.length });
        this.valueChanged();
      }
    });
  }

  getAllResources() {
    this.commonService.getAllResources(this.featureType).subscribe(data => {
      if (data) {
        this.Group = data.map(x => x.resources.resourceGroup);
        this.Group = this.Group.filter((n, i) => this.Group.indexOf(n) === i).sort((a, b) => a > b ? 1 : -1);
        this.content = data.sort((a, b) => a.resources.resourceName > b.resources.resourceName ? 1 : -1);
        this.resourceDetails.push({ type: 'resources', count: this.content.length });
        this.valueChanged();
      }
    });
  }

  calculateDateDiff(uploadedDate) {
    let datediff = 0;
    const currentDate = new Date(new Date().toUTCString());
    const uploadDate = new Date(uploadedDate);
    datediff = Math.floor((Date.UTC(currentDate.getFullYear(), currentDate.getMonth(),
      currentDate.getDate()) - Date.UTC(uploadDate.getFullYear(), uploadDate.getMonth(), uploadDate.getDate())) / (1000 * 60 * 60 * 24));

    if (datediff < 30) {
      return true;
    }
    return false ;
  }
}
